import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { formatText } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import { LabelPanel } from '../common/LabelPanel'
import { RightPanel } from '../common/RightPanel'
import { selectCompanyInfo } from '../store/slice'
import classes from './index.module.scss'

export const ChangeBasic = ({ data, detailKey }) => {
  const { organizationId } = useSelector(selectCompanyInfo)

  const detailData = data[detailKey]

  return (
    <Panel
      renderLabel={() => <LabelPanel data={data} detailData={detailData} />}
      renderRightHeader={() => <RightPanel data={data} detailKey={detailKey} />}
    >
      <Element className={classes.description} style={{ fontSize: 14 }}>
        {formatText(detailData?.description)}
      </Element>
      <Element
        className={classes.content}
        style={{ fontSize: 14, color: '#3A414B' }}
      >
        <Element
          className={classes.contentItem}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <Translate value="alertDetail.PREVIOUS" className="textUppercase" />
          <div className={classes.mt12}>{formatText(detailData?.previous)}</div>
        </Element>
        <Element
          className={classes.contentItem}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <Translate value="alertDetail.CURRENT" className="textUppercase" />
          <div className={classes.mt12}>{formatText(detailData?.current)}</div>
        </Element>
      </Element>
      <Element className="textCenter my1" style={{ color: '#3A414B' }}>
        <Element elementName="span" style={{ color: '#2C73E8' }}>
          <Link
            to={`${COMPONENTS.companyAnalysis.components.companyProfile.route}?organizationId=${organizationId}`}
            target="_blank"
          >
            <Translate value="alertDetail.CLICK_HERE" />
          </Link>
        </Element>
        &nbsp;
        <Translate value="alertDetail.FOR_MORE_INFORMATION" />
      </Element>
    </Panel>
  )
}
